import HyperlinkKpiSatisfaccion from "@/components/functionals/HyperlinkKpiSatisfaccion";
import HyperlinkKpiTechnicalSupportTotal from "@/components/functionals/HyperlinkKpiTechnicalSupportTotal";
import DetalleSatisfaccionCalificacion from "@/components/functionals/DetalleSatisfaccionCalificacion";
import { formatDate } from "../utils";
export const Months = [
  {
    prop: "1",
    name: "Enero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "2",
    name: "Febrero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "3",
    name: "Marzo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "4",
    name: "Abril",
    minWidth: 80,
    aling: "center",
    fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "5",
    name: "Mayo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "6",
    name: "Junio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "7",
    name: "Julio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "8",
    name: "Agosto",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "9",
    name: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 100,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "10",
    name: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "11",
    name: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "12",
    name: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 100,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "total",
    name: "Total",
    minWidth: 80,
    fixed: true,
    formatter: HyperlinkKpiTechnicalSupportTotal
    // formatter: row => FormatPercentSalesKpi(row.total)
  }
];

export const MonthsRabbey3 = [
  {
    prop: "1",
    label: "Enero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "2",
    label: "Febrero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "3",
    label: "Marzo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "4",
    label: "Abril",
    minWidth: 80,
    aling: "center",
    fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "5",
    label: "Mayo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "6",
    label: "Junio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "7",
    label: "Julio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "8",
    label: "Agosto",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "9",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "10",
    label: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "11",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "12",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiSatisfaccion
  },
  {
    prop: "total",
    label: "Total",
    minWidth: 80,
    fixed: true,
    formatter: HyperlinkKpiTechnicalSupportTotal
    // formatter: row => FormatPercentSalesKpi(row.total)
  }
];

export const DetailSatisfaccionKpi = [
  {
    prop: "solicitudid",
    label: "No. Solicitud.",
    minWidth: 100,
    //fixed: true,
    sortable: true
  },
  {
    prop: "fecha",
    label: "Fecha",
    sortable: true,
    minWidth: 80,
    formatter: (row) => formatDate(row.fecha, "DD/MM/yyyy")
  },
  {
    prop: "tipoServicio",
    label: "Tipo de Servicio",
    sortable: true,
    minWidth: 150
  },
  {
    prop: "valoracion",
    label: "Calificación",
    sortable: true,
    minWidth: 100,
    formatter: DetalleSatisfaccionCalificacion
    // formatter: row => FormatStar(row.valoracion)
  },
  {
    prop: "comentary",
    label: "Comentario",
    minWidth: 200
    //fixed: true
    //formatter: row => (row.comentary ? row.comentary : "SIN COMENTARIO")
  }
  // {
  //   prop: "tecnico",
  //   label: "Nombre Técnico",
  //   sortable: true,
  //   minWidth: 200
  // }
  // {
  //   prop: "Status",
  //   label: "Estatus",
  //   minWidth: 80,
  //   fixed: true
  // },
  // {
  //   prop: "ServicioCliente",
  //   label: "Servicio Al Cliente",
  //   minWidth: 100,
  //   fixed: true
  // },
  // {
  //   prop: "valoracion",
  //   label: "Valoración",
  //   sortable: true,
  //   minWidth: 80,
  //   fixed: true
  //   // formatter: row => getTagType(row.valoracion)
  // }
];

export const commentColumns = [
  {
    prop: "user",
    label: "Usuario",
    minWidth: 50,
    fixed: true
  },
  {
    prop: "Fecha",
    label: "Fecha",
    minWidth: 50,
    fixed: true,
    sortable: true,
    formatter: (row) => formatDate(row.Fecha, "DD/MM/yyyy")
  },
  {
    prop: "Comment",
    label: "Comentario",
    minWidth: 200
  }
];
